import { render, staticRenderFns } from "./AutocompleteSubjectGroup.vue?vue&type=template&id=1b708102&scoped=true"
import script from "./AutocompleteSubjectGroup.vue?vue&type=script&lang=js"
export * from "./AutocompleteSubjectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b708102",
  null
  
)

export default component.exports